import { CMDBet } from "./CMDBet"
import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSeatBet implements ICommand
{

	public PlayerID : number = 0;
	public Bet : Array<CMDBet>;

	public constructor()
	{
		this.Bet = new Array<CMDBet>();
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.PlayerID = ba.readInt53();
		let BetSize:number = ba.readUint8();
		while (BetSize-- > 0)
		{
			let BetChild:CMDBet = new CMDBet();
			BetChild.fromBytes(ba);
			this.Bet.push(BetChild);
		}
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint53(this.PlayerID);
		ba.writeUint8(this.Bet.length);
		for (const BetChild of this.Bet)
		{
			let tempBuf = BetChild.toBytes();
			ba.appendBuf(tempBuf.toBuffer());
		}

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSeatBet();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'PlayerID(Q)='+this.PlayerID+' ';
		str += 'Bet_Size(B)='+this.Bet.length + ' ';
		str += 'Bet(CMDBet)=[';
		for (let BetChild in this.Bet)
		{
			if (<number><unknown>BetChild > 0) str += ', ';
			str += this.Bet[BetChild].toString();
		}
		str += '] ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'SeatBet';
	}

}
